import React from "react";

export const AwardsSidebar = () => {
	return (
		<div className="AwardsSidebar">
			Awards Sidebar
		</div>
	)
}
